<template>
  <div>
    <HomeLoggedOut v-if="!isLoggedIn"></HomeLoggedOut>
    <HomeLoggedIn v-if="isLoggedIn"></HomeLoggedIn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HomeLoggedOut from './home/HomeLoggedOut.vue'
import HomeLoggedIn from './home/HomeLoggedIn.vue'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn'])
  },
  methods: {},
  mounted: function () {},
  components: {
    HomeLoggedOut,
    HomeLoggedIn
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue